import store from '@/store/store'
import axios from 'axios'
import { vue } from '@/main.js'
import router from '@/router.js'

let lastToastId = null

export function showLastErrorToast(vue, message, title = 'Erro') {
  // Se já existe um toast anterior, fecha ele
  if (lastToastId !== null) {
    vue.$toast.remove(lastToastId)
  }

  // Cria o novo toast e guarda o id
  lastToastId = vue.$toast.error(message, title, {
    position: 'topRight',
  })
}

const api = axios.create({
  baseURL: 'https://esusfeedback.com.br/api',
})
api.interceptors.request.use(
  function (config) {
    config.headers.authorization = 'Bearer ' + store.state.accessToken

    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)
api.interceptors.response.use(
  (response) => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }

    // Caso o servidor tenha respondido com erro
    if (error.response !== undefined) {
      if (error.response.status === 401 || error.response.status === 403) {
        store.dispatch('logout')
        vue.$router.push('/login')
        if (error.response.data.message === 'Expired token') {
          showLastErrorToast(
            vue,
            'Sessão expirada! Por favor, faça login novamente.',
            'Atenção'
          )
        }
      }

      if (error.config.returnReject) {
        return Promise.reject(error)
      }
    }

    // Caso não tenha resposta (ex: erro de rede, timeout)
    if (error.request) {
      const shouldShowToast = !error.config?.url?.includes(
        'profissional-pec-cnes-datasus'
      )

      if (shouldShowToast) {
        showLastErrorToast(
          vue,
          'Não foi possível se conectar ao servidor. Tente novamente mais tarde ou entre em contato com o suporte.'
        )
      }
    } else {
      // Outros tipos de erro (ex: erro de configuração)
      showLastErrorToast(
        vue,
        'Ocorreu um erro inesperado. Tente novamente mais tarde ou entre em contato com o suporte.'
      )
    }

    return Promise.reject(error)
  }
)

const apiPublic = axios.create({
  baseURL: 'https://esusfeedback.com.br/api',
})

apiPublic.interceptors.response.use(
  (response) => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }

    // Caso o servidor tenha respondido com erro
    if (error.response !== undefined) {
      if (error.config.returnReject) {
        return Promise.reject(error)
      }
    }

    // Caso não tenha resposta (ex: erro de rede, timeout)
    if (error.request) {
      vue.$toast.error(
        'Não foi possível se conectar ao servidor. Tente novamente mais tarde ou entre em contato com o suporte.',
        'Erro',
        {
          position: 'topRight',
        }
      )
    } else {
      // Outros tipos de erro (ex: erro de configuração)
      vue.$toast.error(
        'Ocorreu um erro inesperado. Tente novamente mais tarde ou entre em contato com o suporte.',
        'Erro',
        {
          position: 'topRight',
        }
      )
    }

    return Promise.reject(error)
  }
)

/**
 * API autenticada exclusiva das rotas protegidas do PEP.
 */
const apiPep = axios.create({
  baseURL: 'https://esusfeedback.com.br/api',
})

apiPep.interceptors.request.use(
  (config) => {
    const token = store.getters['pep/token']

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => Promise.reject(error)
)

apiPep.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }

    if (error.response) {
      const status = error.response.status

      if (status === 401 || status === 403) {
        await store.dispatch('pep/logout')
        // vue.$router.push('/login')
      }
    }

    return Promise.reject(error)
  }
)

export { api, apiPublic, apiPep }
